import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { github } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { githubdark } from '../../../../../Utility/HLJS/github-dark';
import { CopyIcon, CheckIcon } from '@phosphor-icons/react';
import { RootState, useAppSelector } from '../../../../../../store';

interface JsonViewerProps {
    content: any;
    className?: string;
    showCopyButton?: boolean;
    copyKey?: string;
    copied: { [key: string]: boolean };
    onCopy: (text: string, key: string) => void;
}

const JsonViewer: React.FC<JsonViewerProps> = ({
    content,
    className = '',
    showCopyButton = false,
    copyKey = '',
    copied,
    onCopy,
}) => {
    const themes = useAppSelector((state: RootState) => (state as any).themes?.allThemes || {});
    const selectedTheme = useAppSelector((state: RootState) => (state as any).themes?.selectedTheme || '');
    const themeColor = themes?.[selectedTheme]?.themeColor ?? 'light';

    const formatJSON = (obj: any): string => {
        try {
            return JSON.stringify(obj, null, 2);
        } catch {
            return String(obj);
        }
    };

    const jsonString = formatJSON(content);
    const isCopied = copied[copyKey] || false;

    return (
        <div className={`relative ${className}`}>
            {showCopyButton && (
                <button
                    onClick={() => onCopy(jsonString, copyKey)}
                    className="absolute top-2 right-2 z-10 p-1 text-layout-textcolor hover:text-primary transition-colors"
                    title="Copy JSON"
                >
                    {isCopied ? <CheckIcon className="w-4 h-4" /> : <CopyIcon className="w-4 h-4" />}
                </button>
            )}
            <SyntaxHighlighter
                language="json"
                style={themeColor === 'light' ? github : (githubdark as any)}
                customStyle={{
                    padding: '1rem',
                    margin: 0,
                    backgroundColor: 'transparent',
                    fontSize: '0.75rem',
                    overflow: 'auto',
                }}
                wrapLongLines={true}
            >
                {jsonString}
            </SyntaxHighlighter>
        </div>
    );
};

export default JsonViewer;
